export enum AthenaEventSaveErrorReason {
  // Known errors returned by the EventStorage backend.
  UniqueViolation = "UNIQUE_VIOLATION",
  Validation = "VALIDATION",
  Unauthorized = "UNAUTHORIZED",
  Addition = "ADDITION",
  // Other errors
  BackendUnreachable = "BACKEND_UNREACHABLE",
  Unknown = "UNKNOWN",
}
